import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Delayed = ({ children, waitBeforeShow = 500 }) => {
  const [isShown, setIsShown] = useState(!waitBeforeShow);

  useEffect(() => {
    waitBeforeShow &&
      setTimeout(() => {
        setIsShown(true);
      }, waitBeforeShow);
  }, [waitBeforeShow]);

  return isShown ? children : null;
};

Delayed.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  waitBeforeShow: PropTypes.any
};
export default Delayed;
